import * as React from 'react'

function Background(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={426}
      height={1002}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M203.5 140c10.333 107.5 13.7 349.1 8.5 455.5-6.5 133-6.5 312.5-6.5 406"
        stroke="#F4BA27"
        strokeWidth={10}
      />
      <path
        d="M38 70.5c24.167 11.5 66.9 50.8 44.5 116"
        stroke="#1978B2"
        strokeWidth={10}
      />
      <path
        d="M371 83c-14.833 15.833-40.7 62.8-25.5 104M421.5 55.5C409.333 68.333 365.3 94 306.5 94"
        stroke="#219321"
        strokeWidth={10}
      />
      <path
        d="M3.5 82.5C14.833 75.333 58 61 128 61"
        stroke="#1978B2"
        strokeWidth={10}
      />
      <rect x={127} width={180} height={144} rx={50} fill="#FEF5DF" />
      <path
        d="M217.498 129.997c32.308 0 58.499-26.191 58.499-58.499 0-32.307-26.191-58.498-58.499-58.498C185.191 13 159 39.19 159 71.498c0 32.308 26.191 58.499 58.498 58.499z"
        fill="#F4BA27"
        fillOpacity={0.5}
      />
      <path
        d="M178.522 88.082c-.147 4.1 3.1 7.67 7.197 7.905.212.013.421.017.631.01 1.935-.046 3.727.994 4.577 2.73 5.081 10.361 15.399 15.861 25.806 16.187 10.522.023 21.125-5.234 26.5-15.628a4.254 4.254 0 014.185-2.285c.134.013.265.023.402.03 4.08.192 7.683-2.973 7.991-7.047a7.647 7.647 0 00-7.497-8.232h-.017c-.801-.013-1.471-.612-1.51-1.413-1.063-21.919-14.893-33.29-28.906-33.627-14.007-.134-28.2 10.754-30.011 32.594a1.538 1.538 0 01-1.56 1.406h-.016a7.648 7.648 0 00-7.772 7.37z"
        fill="#fff"
      />
      <path
        d="M188.824 87.411a.543.543 0 00.366-.951c-.121-.105-2.994-2.57-7.931-1.51a.545.545 0 00.228 1.065c4.375-.935 6.88 1.174 6.984 1.265a.583.583 0 00.353.131z"
        fill="#000"
      />
      <path
        d="M182.164 88.729a.545.545 0 00.455-.229c1.537-2.151 3.743-2.312 3.835-2.318a.542.542 0 00.51-.576.542.542 0 00-.572-.513c-.115.007-2.809.18-4.662 2.773a.543.543 0 00.127.758.513.513 0 00.307.105zM244.779 88.353a.553.553 0 00.353-.121c.108-.088 2.681-2.112 7.023-1.03a.545.545 0 00.265-1.056c-4.898-1.226-7.854 1.141-7.978 1.242a.541.541 0 00-.075.765.548.548 0 00.412.2z"
        fill="#000"
      />
      <path
        d="M251.392 89.893a.542.542 0 00.461-.847c-1.765-2.652-4.453-2.916-4.567-2.926a.54.54 0 00-.589.493.546.546 0 00.494.589c.095.01 2.292.245 3.757 2.446a.538.538 0 00.444.245zM216.16 93.447a.544.544 0 00.193-1.056c-4.228-1.514-4.486-2.24-4.496-2.374-.019-.294 1.063-.866 1.71-1.206.994-.524 2.122-1.119 2.685-1.962 1.677-2.52 1.098-12.156 1.026-13.248a.547.547 0 00-.579-.507.542.542 0 00-.506.579c.186 2.86.402 10.698-.847 12.571-.409.615-1.406 1.141-2.286 1.602-1.212.641-2.36 1.243-2.291 2.25.062.895.974 1.804 5.218 3.321.055.02.114.03.173.03zM214.402 98.047c5.653.095 6.588-4.927 6.598-4.98a.545.545 0 00-1.076-.19c-.032.18-.827 4.274-5.702 4.071-.278-.003-.552.223-.565.524-.013.3.222.552.523.565.075.007.15.01.222.01zM203.531 85.196c.025-1.502-.647-2.732-1.501-2.746-.854-.014-1.566 1.192-1.592 2.694-.025 1.502.647 2.731 1.501 2.746.854.014 1.567-1.192 1.592-2.694zM232.091 85.674c.026-1.503-.646-2.732-1.5-2.746-.854-.015-1.567 1.191-1.592 2.694-.025 1.502.646 2.731 1.5 2.746.854.014 1.567-1.192 1.592-2.694z"
        fill="#000"
      />
      <path
        d="M248.31 81.752s15.556-1.491 13.255-15.066c-2.302-13.575-7.236-12.173-10.067-20.55-2.832-8.376-15.952-15.739-30.763-10.632-14.811 5.107-24.813-6.663-34.722-3.407-9.91 3.257-2.283 11.418-3.989 14.811-1.707 3.394-8.135 5.218-6.484 13.281 1.651 8.063 5.362 21.91 11.502 20.346 5.183-1.317 5.372-21.392 13.873-24.076 7.795-2.462 18.708 9.256 33.003 4.776 1.932-.604 3.907.785 4.024 2.809.367 6.418 2.188 17.547 10.368 17.708z"
        fill="#F4BA27"
      />
      <path
        d="M236.406 79.26c.089 0 .18-.02.265-.062a.545.545 0 00.226-.735c-.036-.07-3.75-6.893-11.077-5.202a.543.543 0 00-.409.654.55.55 0 00.654.408c6.519-1.507 9.835 4.59 9.867 4.653a.553.553 0 00.474.284zM195.988 78.309a.543.543 0 00.481-.271c.143-.249 3.573-6.04 10.017-4.32a.547.547 0 00.667-.385.543.543 0 00-.385-.667c-7.262-1.936-11.205 4.76-11.244 4.829a.544.544 0 00.464.814z"
        fill="#000"
      />
      <path
        d="M238.261 95.66c.37-1.642-2.634-3.718-6.71-4.637-4.076-.92-7.68-.334-8.051 1.308-.37 1.642 2.634 3.718 6.71 4.637 4.076.92 7.681.334 8.051-1.308zM202.271 96.47c4.07-.946 7.06-3.042 6.679-4.681-.382-1.64-3.99-2.201-8.06-1.255-4.069.947-7.06 3.043-6.678 4.682.381 1.64 3.989 2.2 8.059 1.254z"
        fill="#FFDEDE"
      />
      <path
        d="M372.301 63.765l-29.26-14.747 28.976 22.42s-33.219 6.157-36.724-27.473c0 0 33.222-10.031 37.008 19.8zM78.302 145.765L49.04 131.018l28.976 22.42s-33.22 6.158-36.724-27.473c0 0 33.222-10.031 37.009 19.8zM105.58 173.266l13.643-29.792-21.32 29.795s-7.397-32.966 26.08-37.726c0 0 11.266 32.824-18.403 37.723zM80.628 81.654l27.326 18.083-26.142-25.669s33.713-2.213 33.243 31.597c0 0-34.17 6.059-34.427-24.01zM34.631 59.486L47.704 29.44l-20.75 30.195S18.933 26.816 52.313 21.42c0 0 11.89 32.603-17.681 38.067zM357.151 138.165l20.989 25.163-17.678-32.09s32.93 7.554 22.779 39.807c0 0-34.472-4.001-26.09-32.88zM336.034 105.991l-25.822 20.172 32.64-16.641s-8.605 32.671-40.516 21.492c0 0 5.102-34.326 33.698-25.023zM199.954 586.139l-28.083-16.882 27.229 24.512s-33.586 3.671-34.58-30.128c0 0 33.876-7.533 35.434 22.498zM225.307 860.748l17.172-27.906-24.793 26.974s-3.323-33.622 30.484-34.266c0 0 7.181 33.952-22.863 35.198zM225.307 187.748l17.172-27.906-24.793 26.974s-3.323-33.622 30.484-34.266c0 0 7.181 33.952-22.863 35.198z"
        fill="#F4BA27"
      />
    </svg>
  )
}

export default Background
